import { Component,Input, OnInit, Output} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, NavigationExtras } from '@angular/router';
import { ConfirmacionesService} from '../../../services/confirmaciones.service';
import { PagosService} from '../../../services/pagos-service.service';
import { CatalogosService } from '../../../services/catalogos.service';
import { ClientesService } from '../../../services/clientes.service';


@Component({
    selector: 'programar-pago',
    templateUrl: './programar.component.html'
})

export class ProgramarPagoComponent implements OnInit {

    @Input() objetoConfirmacion:Observable<any>;
    @Input() cliente:Observable<any>;
    @Input() servicios:Observable<any>;

    pagosConfirmacion:any=[];
    pago:any={};
    confirmacion:any={}
    confirmacionId:any;

     // Catálogos para pagos
    formasDePago: Observable<any>;
    procesosDePago: Observable<any>;
    constructor(
        public route:Router,
        private pagosService:PagosService,
        private confirmacionesService : ConfirmacionesService,
        private catalogosService: CatalogosService,
        private ClientesService :ClientesService
    ){
        this.pago = {
            factura: false,
            procesoDePago:'',
            iva:0,
            monto:0
        }
    }
    // Función de OnInit
    ngOnInit(){
        //Obtenemos los catlogos y abrimos el objeto de confirmacion para obtener datos que se requieren durante la
        this.formasDePago = this.catalogosService.obtenerFormasDePago().valueChanges().take(1);
        this.procesosDePago = this.catalogosService.obtenerProcesosDePago().valueChanges().take(1);
        this.objetoConfirmacion.subscribe(res=>{
           this.confirmacionId= res.$key;
           this.confirmacion= res.data;
           this.ClientesService.obtenerPropiedadCliente(this.confirmacion.cliente, 'procesoDePago').valueChanges().subscribe(res=>{
            this.pago.procesoDePago=res;
           })
        })
    }
    //Se crea un pago programado y despues de limpia el formulario
    crearPagoProgramado(event){
        event.preventDefault();
        this.pago.idTrosten= this.confirmacion.idTrosten
        this.pago.confirmacionId=this.confirmacionId
        if(this.pago.formaDePago == 'Efectivo Operador')
        {
            this.pagosService.insertarPagoProgramadoEfectivoOperador(this.pago).take(1).subscribe(res => {
                console.log("res",res)
            })
        }
        this.pagosService.insertarPagoProgramado(this.pago).then(()=>{
            this.limpiarFormulario()
        }).catch(error=>console.log(error))
     }
   //Se hace limpieza del formulario
    limpiarFormulario(){
        this.pago = {
            iva:0,
            monto:0}
    }
    //Verifica que la fecha no sea menor a el inicio del primer servicio de la confirmacion
    verificarFecha(fecha){
        this.verificarQueNoSaNull()
        if(this.pagosConfirmacion.length == 0){
            this.servicios.take(1).subscribe((servicio)=>{
                let fechaArreglo=fecha.split('-');
                let fechaNueva= new Date(Number(fechaArreglo[0]),Number(fechaArreglo[1]-1),Number(fechaArreglo[2])).getTime();
                let alerta= false
                servicio.forEach(servicioFor => {
                    if(fechaNueva > servicioFor.inicioDeServicio){
                        alerta=true;
                        this.pago.fechaProgramada=''
                    }
                });
                if(alerta)
                    alert('La fecha debe ser menor')
            })
        }
    }
    //Verifica que  el monto no sea ni menor a 0 o nullo
    verificarQueNoSaNull(){
        if(this.pago.monto< 0 )
            this.pago.monto = 0
        if(this.pago.monto== null )
            this.pago.monto = 0
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/programar-pago/programar-pago.component.ts